$(document).ready(function(){
  $(".toggle-link").click(function(){
    $(this).next().toggle();
    $(this).find("svg").toggleClass("svg-rotate");
  });


  $(".child-link--new").click(function(){
   
 var aa= $(this).attr("data-link");
    var bb= $(this).parent().attr("data-collection");
    
    console.log(aa);
    console.log(bb);
      
});

  var maxHeight = 0;

$(".judge-reviews").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});

$(".judge-reviews").height(maxHeight);
// =============================================== //
   $(".site-nav__dropdown-list").each(function(){
     var num = $(this).find("li").length;
console.log(num);
     if (num >= 10) {
       $(this).addClass("site-nav__dropdown-list-new");
       $(this).parent().parent().addClass("megamenu-new");
     }
   });


  // code for showing images of radio button 

   $('.variant-input').click(function(){
//  var clickedvalue = $(this).data('value');
// $('.vraints-Images-thumbnails').each(function(){
//      var imagevalue = $(this).data('data');
//   console.log(imagevalue);
//        if (clickedvalue == imagevalue)
//        {
//          $(this).click();
//        }
//   });

      var newSrc = $(this).find('.variant-image-block img').attr('src');
    $('.starting-slide .image-wrap img').attr('srcset', newSrc);
   });


$('.gb-pots-varients-img').slick({
        infinite: false,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        prevArrow: $('.gb-pots-varients-img-prev'),
        nextArrow: $('.gb-pots-varients-img-next'),
		 responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 413,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 2
            }
          }
     ]
});  
  


$('body').on('click', '.gb-pots-image-click', function(){   
   $('.gb-pots-image-click').removeClass("active-pot");
   $(this).addClass("active-pot");
  
   /*var get_var =  $(this).attr('attr_variant');
   var get_pro =  $(this).attr('attr_id');
   $('.gb-variant_id_add option').val(get_var);
   $('.gb-product_id_add').val(get_pro);
  
   setTimeout(function () {
       $('.gb-product-tirgger').trigger('click'); 
    }, 1500);*/
  
});
$('body').on('click', '.gb-sumbit-add_pro', function(){   
   var get_var =  $('.gb-pots-image.active-pot').attr('attr_variant');
         $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async:false,
            data:{
                   quantity: 1,
                   id: get_var
                  },
            dataType: 'json',
                success: function(line_item) { 
                   
                 }
          });
  
   /*var get_var =  $(this).attr('attr_variant');
   var get_pro =  $(this).attr('attr_id');
   $('.gb-variant_id_add option').val(get_var);
   $('.gb-product_id_add').val(get_pro);
  
   setTimeout(function () {
       $('.gb-product-tirgger').trigger('click'); 
    }, 1500);*/
  
});  
/*$('body').on('click', '.gb-pots-blank-img', function(event){   
     event.preventDefault();
   $('.gb-variant_id_add option').val(" ");
   $('.gb-product_id_add').val(" ");
});*/



 var proid = $('.gb-cart-first-podid').html();
  var productId= proid; //{ in a template it would be product.id }
  var sectionId="product-recommendations";
  var limit="6";
  var url="/recommendations/products?section_id="+sectionId+"&limit="+limit+"&product_id="+productId;
    fetch(url).then(function (response) {
  
    return response.text();
    }).then(function (html) { //console.log(html);
     // setTimeout(function() {                        
        document.getElementById("product-recs").innerHTML=html;
         // setTimeout(function () {                       
            $('#product-recs .product-recommendations .new-grid.product-grid').slick({
              infinite: false,
              autoplay: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              prevArrow: '<div class="gb-product-recommend-prev"><svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.534257 8.0036L8.68043 15.9056L11.0703 13.5874L5.31402 8.0036L11.0703 2.41982L8.68043 0.101562L0.534257 8.0036Z" fill="#000000"/></svg></div>',
              nextArrow: '<div class="gb-product-recommend-next"><svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4667 7.99249L3.32055 0.0904493L0.930664 2.40871L6.68695 7.99249L0.930664 13.5763L3.32055 15.8945L11.4667 7.99249Z" fill="#000000"/></svg></div>',
           });  
       // }, 2000);   
         // }, 2000);
    }).catch(function (err) {
        console.warn('Something went wrong.', err);
   });
  
//$(".gb-common-recommendations").click(function(){
$('body').on('click', '.gb-common-recommendations', function(){   
  var proid = $(this).attr('proid');
  var productId= proid; //{ in a template it would be product.id }
  var sectionId="product-recommendations";
  var limit="6";
  var url="/recommendations/products?section_id="+sectionId+"&limit="+limit+"&product_id="+productId;
    fetch(url).then(function (response) {
  
    return response.text();
    }).then(function (html) { //console.log(html);
      setTimeout(function() {                        
        document.getElementById("product-recs").innerHTML=html;
         // setTimeout(function () {                       
            $('#product-recs .product-recommendations .new-grid.product-grid').slick({
              infinite: false,
              autoplay: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              prevArrow: '<div class="gb-product-recommend-prev"><svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.534257 8.0036L8.68043 15.9056L11.0703 13.5874L5.31402 8.0036L11.0703 2.41982L8.68043 0.101562L0.534257 8.0036Z" fill="#000000"/></svg></div>',
              nextArrow: '<div class="gb-product-recommend-next"><svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4667 7.99249L3.32055 0.0904493L0.930664 2.40871L6.68695 7.99249L0.930664 13.5763L3.32055 15.8945L11.4667 7.99249Z" fill="#000000"/></svg></div>',
            });  
       // }, 2000);   
          }, 3000);
    }).catch(function (err) {
        console.warn('Something went wrong.', err);
    });
  
});  

$('body').on('click', 'div#product-recs .gb-common-recommendations', function(){  
 /* var quickAddBtns = this.container.querySelectorAll(selectors.quickAddBtn);
     
          quickAddBtns.forEach(btn => {
            btn.addEventListener('click', this.addToCart.bind(this));
          });*/
        $(this).find('span').addClass('btn--loading');
        var get_id_upsell_pro = $(this).attr('data-id');

        var data = {
         'items': [{
          'id': get_id_upsell_pro,
          'quantity': 1
          }]
        };
  
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422 || data.status === 'bad_request') {
             console.log('bb');
          } else {
             console.log('gbgddb');
            var product = data;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this
              }
            }));
          }

           var gb_cart_total_amout_load =  jQuery(".gb-progress-bar-val").attr('max');

         var gb_cart_total_amout_load2 =  jQuery(".rq-cart-limit-val").html();
        setTimeout(function() {
                    jQuery.getJSON('/cart.js', function(cart) {
                        jQuery(".gb-progress-bar-val").val(cart.total_price);
                        var gb_cart_total_load =  cart.total_price;
                        var gb_cart_minus_val =  gb_cart_total_amout_load - gb_cart_total_load;
                        var gb_cart_minus_val_total_val =  theme.Currency.formatMoney(gb_cart_minus_val,  theme.settings.moneyFormat);
        
                        if(gb_cart_total_load >= gb_cart_total_amout_load) {
                           jQuery(".free-product-progress-bar-successfull").html('🎉 <strong>Geniet van je gratis verzending!</strong>');
                        }else {  
                           jQuery(".free-product-progress-bar-successfull").html('Besteed nog maar <strong>'+gb_cart_minus_val_total_val+'</strong> en ontvang <strong>GRATIS VERZENDING!</strong>');
                        }

                        var gb_cart_total_load2 =   cart.total_price;
                        if(gb_cart_total_load2 >= gb_cart_total_amout_load2) { 
                           //$('.gb-cart-limit').show();
                           $('.gb-cart-limit').removeClass('gb-disabled-cart-btn'); 
                           $('.gb-spend-money').hide();
                        }else {   
                          //$('.gb-cart-limit').hide();
                          $('.gb-cart-limit').addClass('gb-disabled-cart-btn');
                           $('.gb-spend-money').show();
                        } 
                     });
          
                 
          }, 1000);
          
  
          $(this).find('span').removeClass('btn--loading');
        }.bind(this));
});
  


/*$(".rq-change-click").change(function() {
    //setTimeout(function() {
      $(".rq-submit-currency").trigger("click");
   // }, 2000);   
});*/

$(".rq-change-click").click(function() {
    var grt_val_lang = $(this).attr('value');
    $('.gb-add-lang-val').val(grt_val_lang); 
    setTimeout(function() {
      $(".rq-submit-currency").trigger("click");
    }, 500);   
});
  
/*$(".rq-change-click2").change(function() {
    //setTimeout(function() {
      $(".rq-submit-currency2").trigger("click");
   // }, 2000);   
});*/

$(".rq-change-click2").click(function() {
    var grt_val_lang = $(this).attr('value');
    $('.gb-add-lang-val2').val(grt_val_lang); 
    setTimeout(function() {
      $(".rq-submit-currency2").trigger("click");
    }, 500);   
});  

$(".rq-change-click3").click(function() {
    var grt_val_lang = $(this).attr('value');
    $('.gb-add-lang-val3').val(grt_val_lang); 
    setTimeout(function() {
      $(".rq-submit-currency3").trigger("click");
    }, 500);   
});   


$('.gb-trust-badges-main').slick({
        infinite: false,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        //prevArrow: $('.gb-pots-varients-img-prev'),
        //nextArrow: $('.gb-pots-varients-img-next'),
		 responsive: [
          {
            breakpoint: 1023,
            settings: {
              autoplay: true,
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              autoplay: true,
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          } 
     ]
});  
  
  
});